import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { Prescription } from '../prescription/prescription';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {

  private prescriptionsUrl = 'api/prescriptions';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  searchPrescriptionsByPatientId(patientId: number): Observable<Prescription[]> {
    if (patientId < 1) { return of([]); }
    return this.http
      .get<Prescription[]>(`${this.prescriptionsUrl}/?patientId=${patientId}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  createPrescription(prescription: Prescription): Observable<Prescription> {
    return this.http
      .post<Prescription>(this.prescriptionsUrl, prescription, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
